module.exports = __webpack_public_path__ + "static/media/catalouge-24.acfbbd5f.jpg";